@if (!isReadOnly) {
  <input
    type="text"
    [(ngModel)]="bindingProperty"
    (ngModelChange)="dataChanged()"
    [placeholder]="(isReadOnly && !bindingProperty) || !label ? '' : 'Add ' + label"
    [class.error]="!isValid"
    />
    <app-validation-error-message [show]="!isValid" [errors]="validationErrors"></app-validation-error-message>
  } @else {
    @if (bindingProperty) {
      <a
        [href]="bindingProperty | ensureHttps"
        target="_blank"
        rel="noopener noreferrer"
        appEnsureHttps
        >
        <button class="resetStyles">
          @switch (fieldName) {
            @case ('linkedin') {
              <div class="icon" [innerHTML]="profileIcon"></div>
              <span>Visit profile</span>
            }
            @default {
              <div class="icon" [innerHTML]="websiteIcon"></div>
              <span>Visit website</span>
            }
          }
        </button>
      </a>
    }
  }

